import context from '@truckdown/components-systems';
import { IUserManager, UserModel, UpdateUserSecuritySettingsModel } from "@truckdown/accounts";
import { defineComponent, ref, Ref, computed, onMounted } from "vue";
import { showMessage, isFleet } from "../../../Utilities/Utilities";

interface IData {
    isLoading: Ref<boolean>,
    userProfile: Ref<UserModel>,
    updateModel: Ref<UpdateUserSecuritySettingsModel>
};

const getInitialData = function (props: any) {
    var update = {
        id: props.userProfile.id,
        allowRatings: getAllowRatings(props.userProfile),
        editNotes: getEditNotes(props.userProfile),
        advancedPreferences: getAdvancedOptions(props.userProfile),
        addFavoriteAvoid: getPreferredVendors(props.userProfile),
        isAdmin: props.userProfile.isAdmin
    } as UpdateUserSecuritySettingsModel;

    return {
        isLoading: ref<boolean>(false),
        userProfile: ref<UserModel>(props.userProfile),
        updateModel: ref<UpdateUserSecuritySettingsModel>(update)
    } as IData;
}

const getAllowRatings = function (userProfile: UserModel) {
    var allowRatings = userProfile.claims.find(c => {
        return c.type == "search_ratings";
    });

    return (allowRatings?.value ?? "False") == "True";
}

const getEditNotes = function (userProfile: UserModel) {
    var editNotes = userProfile.claims.find(c => {
        return c.type == "search_edit_notes";
    });

    return (editNotes?.value ?? "False") == "True";
}

const getPreferredVendors = function (userProfile: UserModel) {
    var preferredVendors = userProfile.claims.find(c => {
        return c.type == "search_preferred_vendors";
    });

    return (preferredVendors?.value ?? "False") == "True" && isFleet();
}

const getAdvancedOptions = function(userProfile: UserModel) {
    var advancedOptions = userProfile.claims.find(c => {
        return c.type == "search_advanced_options";
    });

    return (advancedOptions?.value ?? "False") == "True" && isFleet();
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        editSecuritySettingsCancelClick: function (): void {
            ctx.emit(userCancelEventName);
        },
        editSecuritySettingsSaveClick: async function (): Promise<void> {
            await saveUser(data, props, ctx);
        }
    }
}

const saveUser = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;

        try {
            if (isUserModelValid(data.userProfile.value)) {
                let userManager = await context.getService<IUserManager>('IUserManager');

                var response = await userManager.updateSecuritySettings(data.updateModel.value);

                if (!response || !response.ok) {
                    console.log("Error updating user security settings: " + response.message);
                    showMessage("Error updating user security settings.", "danger", true, true);
                } else {
                    showMessage("User Security Settings was successfully updated.", "success", true, true);
                    ctx.emit(userUpdatedEventName, response.data);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const isUserModelValid = function (userModel: UserModel): boolean {


    return true;
}

const userUpdatedEventName = 'update';
const userCancelEventName = 'cancel';

export default defineComponent({
    props: {
        userProfile: {
            type: Object as () => UserModel,
            required: true
        }
    },
    components: {
    },
    emits: [userUpdatedEventName, userCancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...methods
        };
    }
});